// import { useEffect, useRef } from "react";
// import api from "../../api";
// import GalleryTool from "./tools/GalleryTool";

// export default function Editor({ data, onChange }) {
//   const editorRef = useRef(null);
//   const holderRef = useRef(null);

//   useEffect(() => {
//     let editor;

//     const init = async () => {
//       const EditorJS = (await import("@editorjs/editorjs")).default;
//       const Header = (await import("@editorjs/header")).default;
//       const List = (await import("@editorjs/list")).default; // checklist List дотор байна
//       const Quote = (await import("@editorjs/quote")).default;
//       const Warning = (await import("@editorjs/warning")).default;
//       const Delimiter = (await import("@editorjs/delimiter")).default;
//       const Table = (await import("@editorjs/table")).default;
//       const Embed = (await import("@editorjs/embed")).default;
//       const Marker = (await import("@editorjs/marker")).default;
//       const InlineCode = (await import("@editorjs/inline-code")).default;
//       const Underline = (await import("@editorjs/underline")).default;
//       const TextVariantTune = (await import("@editorjs/text-variant-tune"))
//         .default;
//       const DragDrop = (await import("editorjs-drag-drop")).default;
//       const Undo = (await import("editorjs-undo")).default;
//       const ImageTool = (await import("@editorjs/image")).default;
//       const Paragraph = (await import("@editorjs/paragraph")).default;
//       const AlignmentTune = (await import("editorjs-text-alignment-blocktune"))
//         .default;

//       let Gallery = null;
//       try {
//         Gallery = (await import("editorjs-gallery")).default;
//       } catch {
//         /* байхгүй бол алгасна */
//       }

//       if (!holderRef.current) return;

//       const uploadFile = async (file) => {
//         const formData = new FormData();
//         formData.append("image", file);
//         const res = await api.upload_image(formData);
//         return { success: 1, file: { url: res.data.url } };
//       };

//       const tools = {
//         paragraph: {
//           class: Paragraph,
//           tunes: ["textVariant", "alignment"],
//         },

//         header: {
//           class: Header,
//           config: { levels: [1, 2, 3, 4, 5, 6], defaultLevel: 2 },
//           tunes: ["alignment"],
//         },

//         // checklist List-ийн дотор style-аар ирнэ — тусдаа checklist tool хэрэггүй
//         list: {
//           class: List,
//           inlineToolbar: true,
//           config: { defaultStyle: "unordered" },
//         },

//         quote: {
//           class: Quote,
//           inlineToolbar: true,
//           config: {
//             quotePlaceholder: "Иш үгээ бичнэ үү...",
//             captionPlaceholder: "Зохиогч",
//           },
//         },

//         warning: {
//           class: Warning,
//           inlineToolbar: true,
//           config: {
//             titlePlaceholder: "Гарчиг",
//             messagePlaceholder: "Дэлгэрэнгүй...",
//           },
//         },

//         table: {
//           class: Table,
//           inlineToolbar: true,
//           config: { rows: 3, cols: 3, withHeadings: true },
//         },

//         image: {
//           class: ImageTool,
//           config: {
//             uploader: {
//               uploadByFile: uploadFile,
//               uploadByUrl: async (url) => ({ success: 1, file: { url } }),
//             },
//           },
//         },

//         gallery: {
//           class: GalleryTool,
//           config: {
//             uploader: { uploadByFile: uploadFile },
//           },
//           tunes: [],
//         },

//         embed: {
//           class: Embed,
//           config: {
//             services: {
//               youtube: true,
//               vimeo: true,
//               coub: true,
//               codepen: true,
//               twitter: true,
//               facebook: true,
//             },
//           },
//         },

//         delimiter: Delimiter,

//         marker: { class: Marker, shortcut: "CMD+SHIFT+M" },
//         inlineCode: { class: InlineCode, shortcut: "CMD+SHIFT+C" },
//         underline: { class: Underline, shortcut: "CMD+U" },

//         textVariant: TextVariantTune,
//         alignment: {
//           class: AlignmentTune,
//           config: { default: "left", blocks: { header: "left", list: "left" } },
//         },
//       };

//       editor = new EditorJS({
//         holder: holderRef.current,
//         data: data || {},
//         tools,
//         inlineToolbar: [
//           "bold",
//           "italic",
//           "underline",
//           "marker",
//           "inlineCode",
//           "link",
//         ],
//         tunes: ["textVariant", "alignment"],
//         placeholder: "Энд бичиж эхлэнэ үү...",

//         onReady() {
//           new DragDrop(editor);
//           new Undo({ editor });
//         },

//         async onChange(api) {
//           const saved = await api.saver.save();
//           onChange?.(saved);
//         },
//       });

//       editorRef.current = editor;
//     };

//     init();

//     return () => {
//       editorRef.current?.destroy();
//       editorRef.current = null;
//     };
//   }, []);

//   return <div ref={holderRef} />;
// }

import { useEffect, useRef } from "react";
import api from "../../api";
import GalleryTool from "./tools/GalleryTool";

/* ── Image tool-д link field нэмэх + бүдэг border wrapper ────────────── */
function withImageExtensions(ImageToolClass) {
  return class ExtendedImageTool extends ImageToolClass {
    constructor(args) {
      super(args);
      this._data = {
        ...this._data,
        link: args.data?.link || "",
      };
    }

    render() {
      const wrapper = super.render();
      this._addStyles();

      setTimeout(() => {
        // ── Зураг байвал л link input харуулна ──
        const img = wrapper.querySelector("img");
        if (img) {
          this._injectLinkInput(wrapper);
        } else {
          // Зураг хожим орох үед ажиглана
          const observer = new MutationObserver(() => {
            const img = wrapper.querySelector("img");
            if (img) {
              observer.disconnect();
              this._injectLinkInput(wrapper);
            }
          });
          observer.observe(wrapper, { childList: true, subtree: true });
        }
      }, 100);

      // ReadOnly горимд зураг дээр дарвал link руу шилжинэ
      wrapper.addEventListener("click", (e) => {
        if (this._data.link && this.readOnly) {
          const img = wrapper.querySelector("img");
          if (img && img.contains(e.target)) {
            window.open(this._data.link, "_blank", "noopener,noreferrer");
          }
        }
      });

      return wrapper;
    }

    _addStyles() {
      if (document.getElementById("ext-image-tool-styles")) return;
      const style = document.createElement("style");
      style.id = "ext-image-tool-styles";
      style.textContent = `
      .image-tool__image {
  width: 100% !important;
}

.image-tool__image-picture {
  width: 100% !important;
  height: auto !important;
  display: block !important;
}
  
        /* ── Image border ───────────────────────────────── */
        .image-tool__image-picture {
          border-radius: 8px !important;
          box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06) !important;
          overflow: hidden;
        }

        /* ── Caption-г wrapper-т оруулах ──────────────── */
        .ext-image-caption-wrap {
          display: flex;
          align-items: center;
          margin-top: 8px;
        }
        .ext-image-caption-wrap .image-tool__caption {
          flex: 1 !important;
          font-size: 13px !important;
          color: #64748b !important;
          padding: 8px 14px !important;
          border: 1.5px solid #e2e8f0 !important;
          border-radius: 10px !important;
          margin-top: 0 !important;
          transition: border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                      box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif !important;
          background: #fff !important;
        }
        .ext-image-caption-wrap .image-tool__caption:hover {
          border-color: #cbd5e1 !important;
        }
        .ext-image-caption-wrap .image-tool__caption:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          color: #1a1a2e !important;
        }
        .ext-image-caption-wrap .image-tool__caption[data-placeholder]::before {
          color: #cbd5e1 !important;
        }

        /* ── Link input wrapper ─────────────────────────── */
        .ext-image-link-wrap {
          display: flex;
          align-items: center;
          margin-top: 6px;
          padding: 0;
        }

        .ext-image-link-input {
          flex: 1;
          border: 1.5px solid #e2e8f0;
          border-radius: 10px;
          padding: 8px 14px;
          font-size: 13px;
          font-weight: 500;
          color: #1a1a2e;
          outline: none;
          transition: border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                      box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
          background: #fff;
          box-sizing: border-box;
        }
        .ext-image-link-input:hover {
          border-color: #cbd5e1;
        }
        .ext-image-link-input:focus {
          border-color: #2563eb;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }
        .ext-image-link-input::placeholder {
          color: #cbd5e1;
          font-weight: 400;
        }
      `;
      document.head.appendChild(style);
    }

    _injectLinkInput(wrapper) {
      const captionEl = wrapper.querySelector(
        ".cdx-input[contenteditable], .image-tool__caption",
      );
      const parent = captionEl?.parentElement || wrapper;

      if (parent.querySelector(".ext-image-link-wrap")) return;

      if (captionEl && !captionEl.getAttribute("data-placeholder")) {
        captionEl.setAttribute("data-placeholder", "Тайлбар бичнэ үү...");
      }

      // ── Caption-г icon-тэй wrapper-т оруулах ──
      if (
        captionEl &&
        !captionEl.parentElement?.classList.contains("ext-image-caption-wrap")
      ) {
        const captionWrap = document.createElement("div");
        captionWrap.className = "ext-image-caption-wrap";

        captionEl.before(captionWrap);
        captionWrap.appendChild(captionEl);
      }

      // ── Link input ──
      const linkWrap = document.createElement("div");
      linkWrap.className = "ext-image-link-wrap";
      if (this._data.link) linkWrap.classList.add("ext-image-link-active");

      const linkInput = document.createElement("input");
      linkInput.className = "ext-image-link-input";
      linkInput.type = "url";
      linkInput.placeholder = "Холбоос оруулах (https://...)";
      linkInput.value = this._data.link || "";

      linkInput.addEventListener("input", (e) => {
        this._data.link = e.target.value;
        linkWrap.classList.toggle("ext-image-link-active", !!e.target.value);
      });

      linkInput.addEventListener("keydown", (e) => {
        e.stopPropagation();
      });

      linkWrap.appendChild(linkInput);

      // Caption wrap-ийн ард эсвэл parent-д нэмнэ
      const captionWrap = parent.querySelector(".ext-image-caption-wrap");
      if (captionWrap) {
        captionWrap.after(linkWrap);
      } else {
        parent.appendChild(linkWrap);
      }
    }

    save(blockContent) {
      const saved = super.save(blockContent);
      return {
        ...saved,
        link: this._data.link || "",
      };
    }
  };
}

export default function Editor({ data, onChange }) {
  const editorRef = useRef(null);
  const holderRef = useRef(null);

  useEffect(() => {
    let editor;

    const init = async () => {
      const EditorJS = (await import("@editorjs/editorjs")).default;
      const Header = (await import("@editorjs/header")).default;
      const List = (await import("@editorjs/list")).default;
      const Quote = (await import("@editorjs/quote")).default;
      const Warning = (await import("@editorjs/warning")).default;
      const Delimiter = (await import("@editorjs/delimiter")).default;
      const Table = (await import("@editorjs/table")).default;
      const Embed = (await import("@editorjs/embed")).default;
      const Marker = (await import("@editorjs/marker")).default;
      const InlineCode = (await import("@editorjs/inline-code")).default;
      const Underline = (await import("@editorjs/underline")).default;
      const TextVariantTune = (await import("@editorjs/text-variant-tune"))
        .default;
      const DragDrop = (await import("editorjs-drag-drop")).default;
      const Undo = (await import("editorjs-undo")).default;
      const ImageTool = (await import("@editorjs/image")).default;
      const Paragraph = (await import("@editorjs/paragraph")).default;
      const AlignmentTune = (await import("editorjs-text-alignment-blocktune"))
        .default;

      let Gallery = null;
      try {
        Gallery = (await import("editorjs-gallery")).default;
      } catch {
        /* байхгүй бол алгасна */
      }

      if (!holderRef.current) return;

      const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("image", file);
        const res = await api.upload_image(formData);
        return { success: 1, file: { url: res.data.url } };
      };

      const ExtendedImageTool = withImageExtensions(ImageTool);

      const tools = {
        paragraph: {
          class: Paragraph,
          tunes: ["textVariant", "alignment"],
        },

        header: {
          class: Header,
          config: { levels: [1, 2, 3, 4, 5, 6], defaultLevel: 2 },
          tunes: ["alignment"],
        },

        list: {
          class: List,
          inlineToolbar: true,
          config: { defaultStyle: "unordered" },
        },

        quote: {
          class: Quote,
          inlineToolbar: true,
          config: {
            quotePlaceholder: "Иш үгээ бичнэ үү...",
            captionPlaceholder: "Зохиогч",
          },
        },

        warning: {
          class: Warning,
          inlineToolbar: true,
          config: {
            titlePlaceholder: "Гарчиг",
            messagePlaceholder: "Дэлгэрэнгүй...",
          },
        },

        table: {
          class: Table,
          inlineToolbar: true,
          config: { rows: 3, cols: 3, withHeadings: true },
        },

        image: {
          class: ExtendedImageTool,
          config: {
            captionPlaceholder: "Тайлбар бичнэ үү...",
            uploader: {
              uploadByFile: uploadFile,
              uploadByUrl: async (url) => ({ success: 1, file: { url } }),
            },
          },
        },

        gallery: {
          class: GalleryTool,
          config: {
            uploader: { uploadByFile: uploadFile },
          },
          tunes: [],
        },

        embed: {
          class: Embed,
          config: {
            services: {
              youtube: true,
              vimeo: true,
              coub: true,
              codepen: true,
              twitter: true,
              facebook: true,
            },
          },
        },

        delimiter: Delimiter,

        marker: { class: Marker, shortcut: "CMD+SHIFT+M" },
        inlineCode: { class: InlineCode, shortcut: "CMD+SHIFT+C" },
        underline: { class: Underline, shortcut: "CMD+U" },

        textVariant: TextVariantTune,
        alignment: {
          class: AlignmentTune,
          config: {
            default: "left",
            blocks: { header: "left", list: "left" },
          },
        },
      };

      editor = new EditorJS({
        holder: holderRef.current,
        data: data || {},
        tools,
        inlineToolbar: [
          "bold",
          "italic",
          "underline",
          "marker",
          "inlineCode",
          "link",
        ],
        tunes: ["textVariant", "alignment"],
        placeholder: "Энд бичиж эхлэнэ үү...",

        onReady() {
          new DragDrop(editor);
          new Undo({ editor });
        },

        async onChange(api) {
          const saved = await api.saver.save();
          onChange?.(saved);
        },
      });

      editorRef.current = editor;
    };

    init();

    return () => {
      editorRef.current?.destroy();
      editorRef.current = null;
    };
  }, []);

  return <div ref={holderRef} />;
}
